import AuthenticationStrategy from '../../authenticationStrategy';

export default class NoopAuthStrategy extends AuthenticationStrategy {
  roles = [];
  claims = {};
  isLoggedIn = true;
  needsRefresh = false;
  user = undefined;
  role = undefined;
  getUser() { return Promise.resolve(undefined); }
  refresh() { return Promise.resolve(); }
  login() { return Promise.resolve(); }
  logout() { return Promise.resolve(); }
}
